<div class="menuModal">
  <div class="title">{{ getTitle() | translate }}</div>
  @switch (activeAction()) {
    <!--    МЕНЮ-->
    @case ("menu") {
      <button class="btn action" (click)="activeAction.set('profileSettings')">
        {{ "profilePage.profileSettings" | translate }}
      </button>
      <button class="btn action" (click)="activeAction.set('authData')">
        {{ "profilePage.authData" | translate }}
      </button>
      <button class="btn action" (click)="activeAction.set('linkAccount')">
        {{ "profilePage.linkAccount" | translate }}
      </button>
      <button
        class="btn action deleteAccount"
        (click)="activeAction.set('deleteAccount')"
      >
        {{ "profilePage.deleteProfileSection" | translate }}
      </button>
    }
    <!--    НАСТРОЙКИ ПРОФИЛЯ-->
    @case ("profileSettings") {
      <app-profile-settings>
      </app-profile-settings>
    }
    <!--    ДАННЫЕ ДЛЯ АВТОРИЗАЦИИ-->
    @case ("authData") {
      <app-auth-data>
      </app-auth-data>
    }
    <!--    СВЯЗАННЫЕ АККАУНТЫ-->
    @case ("linkAccount") {
      <app-linked-account>
      </app-linked-account>
    }
    <!--    УДЕЛИНЕ УЧЕТНОЙ ЗАПИСИ-->
    @case ("deleteAccount") {
      <div class="deleteAccount">
        <div class="deleteAccount-description">
          {{ "profilePage.deleteAccount_description" | translate }}
        </div>
        <button class="btn delete" (click)="deleteUser()">
          {{ "profilePage.deleteProfile" | translate }}
        </button>
        <button class="btn" (click)="activeAction.set('menu')">
          {{ "global.cancel" | translate }}
        </button>
      </div>
    }
  }
</div>
